module.exports = __webpack_public_path__ + "img/b_intro_2.7123942.png";